import React from "react";
import { COURSE_LIST_WIDTH } from "../../constants/cssConstants";
import CourseLists from "./CourseLists";
import compareArrays from "../../utils/compareArrays";

class RightCoursesLists extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            geCoursesList: props.geCoursesList,
            minorCoursesList: props.minorCoursesList
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.height !== this.props.height
            || !compareArrays(prevProps.geCoursesList, this.props.geCoursesList
            || !compareArrays(prevProps.minorCoursesList, this.props.minorCoursesList))) {
            this.setState({
                geCoursesList: this.props.geCoursesList,
                minorCoursesList: this.props.minorCoursesList
            })
        }
    }

    render() {
        const doesMinorExist = this.state.minorCoursesList.length > 0
        return(
            <div>
                <CourseLists
                    listTitle={ "G.E. Courses" }
                    courses={ this.props.geCoursesList }
                    height={ this.props.height / (doesMinorExist ? 2 : 1) }
                    changed={this.props.changed}
                />
                {
                    doesMinorExist
                        && <CourseLists
                            listTitle={ "Minor Courses" }
                            courses={ this.props.minorCoursesList }
                            height={ this.props.height / 2 }
                            changed={this.props.changed}
                        />
                }
            </div>
        );
    }
}

export default RightCoursesLists;